module.exports = __webpack_public_path__ + "static/media/snap-on-100-logo.c10f8b7c.svg";